<div class="bc-transfer-panel bc-panel" tabindex="-1">
  <div class="bc-transfer-panel-content">
    <div class="bc-transfer-panel-header-text">
      <span>{{ 'bcTransferPanel.assignHeaderDescription' | translate }}</span>
    </div>

    <app-operators-list #operatorList [workItemType]="workItemType"
                        [isOfflineItemSelectable]="isOfflineItemsTransferable"
                        [isAcdAvailable]="true"
                        [isDepartmentSelectable]="true"
                        (onOperatorSelected)="changeSelection($event)"
                        (onSubmitActionTriggered)="assignWorkItemWithKeyboard()">
    </app-operators-list>

    <div class="bc-transfer-panel-buttons center">
      <div class="error-message" [attr.data-automation-id]="'bc-transfer-error-message'">
        {{ errorMessage | translate }}
      </div>

      <button class="btn btn-dark center js-assign-button"
              [disabled]="!selectedItem"
              (click)="assignWorkItem()"
              [attr.data-automation-id]="'bc-transfer-assign-button'">
        <span>{{ 'bcTransferPanel.assignButton' | translate }}</span>
      </button>

      <button class="btn btn-light center js-chat-transfer-back-button"
              (click)="backButtonClicked()"
              [attr.data-automation-id]="'bc-transfer-back-button'">
        <span>{{ 'bcTransferPanel.cancelButton' | translate }}</span>
      </button>
    </div>
  </div>
</div>
